import React from "react"
import { CircleCheck, Info, TriangleAlert } from "lucide-react"
import {
  TOAST_BASE_CLASS,
  TOAST_ICON_SIZE,
  TOAST_VARIANT_CONFIG,
  type ToastType,
} from "./toastNotificationStyles"

export interface ToastNotificationProps {
  message: string
  type: ToastType
}

const TOAST_ICONS = {
  info: Info,
  "circle-check": CircleCheck,
  "triangle-alert": TriangleAlert,
}

const ToastNotification: React.FC<ToastNotificationProps> = ({ message, type }) => {
  const config = TOAST_VARIANT_CONFIG[type]
  const Icon = TOAST_ICONS[config.icon]

  return (
    <div
      className={`${TOAST_BASE_CLASS} ${config.className}`}
      data-toast-variant={type}
      role={config.role}
    >
      <Icon
        aria-hidden={true}
        className={`shrink-0 ${config.iconClassName}`}
        size={TOAST_ICON_SIZE}
        strokeWidth={1.25}
      />
      <span className="min-w-0 break-words">{message}</span>
    </div>
  )
}

export default ToastNotification
